import {Captcha} from "../api/Captcha";

export type Assessment = {
    isLegitimate: boolean,
    score: number,
    token: string,
};

export async function getAssessment(action: string, key: string|null = null): Promise<Assessment | null> {
    const token = await getCaptchaToken(action, key);

    if (token === null) {
        return null;
    }

    const result = await Captcha.createAssessment(token, 3000);
    return {
        isLegitimate: result.isLegitimate,
        score: result.score,
        token: token,
    };
}

export function getCaptchaKey(): string|null {
    return document.head.querySelector<HTMLMetaElement>('meta[name="recaptcha-key"]')?.content ?? null;
}

export async function getCaptchaToken(action: string, key: string|null = null): Promise<string|null> {
    key ??= getCaptchaKey();
    if (key === null) {
        return null;
    }
    try {
        return grecaptcha.enterprise.execute(key, {action: action});
    } catch (e) {
        console.error(e);
        return null;
    }
}

